/** Cash Flow lines that support hover drill-down (like P&L expense hover). */
export const CF_BREAKDOWN_LINE_IDS = [
  'CF5',
  'CF13',
  'CF14',
  'CF15',
  'CF17',
  'CF18',
  'CF20',
  'CF22',
] as const;

export type CfBreakdownLineId = (typeof CF_BREAKDOWN_LINE_IDS)[number];

export function isCfBreakdownLineId(lineId: string): lineId is CfBreakdownLineId {
  return (CF_BREAKDOWN_LINE_IDS as readonly string[]).includes(lineId);
}

export function cfBreakdownCategoryHints(
  lineId: string
): { categories: string[]; note?: string } | null {
  switch (lineId) {
    case 'CF5':
      return {
        categories: ['OPD_BILL_PAYMENTS', 'IPD_DEPOSITS'],
        note: 'Cash basis by payment date. IPD includes desk and TPA settlement (TOP_UP) deposits; collected pending rows are not listed separately.',
      };
    case 'CF13':
      return {
        categories: [
          'PHARMA_PAYOUT',
          'OUTSIDE_LAB_PAYOUT',
          'SURGEON_PAYOUT',
          'REFERRAL',
          'ONLINE_MARKETING',
          'OPD_PAYOUT',
          'ANESTHETIST_PAYOUT',
          'ASSISTANT_SURGEON_PAYOUT',
          'IMPLANT_COST_HOSPITAL',
          'REFERRAL_PAYOUT',
        ],
        note: 'Central + patient payouts paid in the period.',
      };
    case 'CF14':
      return { categories: ['LOAN_EMI'] };
    case 'CF15':
      return {
        categories: [],
        note: 'Expenses with TDS deposited (tdsPaidAt) in the period.',
      };
    case 'CF17':
      return {
        categories: ['SALARY', 'SALARY_ADVANCE', 'INCENTIVES_BONUS'],
        note: 'Hospital-unit salary paid (excludes Central tag).',
      };
    case 'CF18':
      return {
        categories: ['SALARY', 'SALARY_ADVANCE', 'INCENTIVES_BONUS'],
        note: 'Hospital–Central salary paid.',
      };
    case 'CF20':
      return { categories: ['HOSPITAL_RENT', 'PROFESSIONAL_FEES'] };
    case 'CF22':
      return {
        categories: ['CAPEX_HOSPITAL', 'EQUIPMENT_PURCHASE', 'FUNDING_EXPENSES', 'OTHER_EXPENSES'],
        note: 'Capex / funding / equipment; OTHER_EXPENSES ≥ ₹50,000.',
      };
    default:
      return null;
  }
}

export function formatCfBreakdownCategoryLabel(category: string): string {
  return category
    .split('_')
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(' ');
}
